import { InjectionToken } from '@angular/core';

import type { Observable } from 'rxjs';

import type { ScopeStrategy } from '@core/bulk-actions-types';
import type { OfferFull } from '@core/offers-types';
import type { IconName } from '@core/user-interface-legacy';

export interface BulkItemBase {
  id: number | string;
}

export interface CandidateBulkItem extends BulkItemBase {
  id: number;
  stageId?: number;
  isAnonymous?: boolean;
  isHired?: boolean;
  emails: string[];
  name: string;
  createdAt?: string;
  placements?: Array<{
    id: number;
    disqualifyReason: string;
    offer: { id: number };
    ratingVisible: boolean;
    stage?: {
      id: number;
    };
    candidateId: number;
    screeningEnabled?: boolean;
  }>;
}

export enum BulkActionType {
  AddWorkLocations,
  AddSources,
  AddTags,
  AddTask,
  Archive,
  Assign,
  Unassign,
  Disqualify,
  Requalify,
  SendEEO,
  SendMail,
  Share,
  ChangeStage,
  Delete,
  Extend,
  Follow,
  Unfollow,
  ManageReferrals,
  Retrieve,
  ManageEeo,
  DeleteArchived,
  RetrieveArchived,
  Merge,
  Submit,
  Withdraw,
  ScreenAgain,
  RequestEvaluation,
}

export type BulkActionId<T extends string> = `bulk-action-${T}`;
export interface BulkAction {
  id: number | BulkActionId<string>;
  buttonLabel?: string;
  buttonIcon?: IconName;
  analytics?: string | (() => void);
  analyticsWithPayload?: (payload: unknown) => void;
  isNew?: boolean;
  scopeStrategy?: ScopeStrategy;
}

export type GetBulkActionsProps<
  OfferScope extends string = string,
  RequisitionsScope extends string = string,
> =
  | {
      offer?: Pick<OfferFull, 'kind' | 'status' | 'hireAssistant'>;
      offersScope?: OfferScope;
      requisitionsScope?: RequisitionsScope;
    }
  | undefined;

export type BulkSelectionTrackerItemFilter = <T extends BulkItemBase = BulkItemBase>(
  items: T[],
) => Observable<T[]>;
export const BULK_SELECTION_TRACKER_ITEM_FILTER: InjectionToken<BulkSelectionTrackerItemFilter> =
  new InjectionToken('BULK_SELECTION_TRACKER_ITEM_FILTER');

export type BulkActionsContext<
  OfferScope extends string = string,
  ViewType extends string = string,
> =
  | {
      offer?: Pick<OfferFull, 'kind' | 'status' | 'hireAssistant'>;
      offersScope?: OfferScope;
      searchViewType?: ViewType;
    }
  | undefined;
